export const tableProps = (state) => state.operationReport.table
export const creditEmployees = (state) => state.operationReport.creditEmployees
export const employees = (state) => state.operationReport.employees
export const session = (state) => state.session
